import firebase from "firebase";
import "firebase/firestore";

// firebase init goes here
const config = {
  apiKey: "AIzaSyA2A7XBRyCtzuRq4zGYVY_5C0czhOytpyg",
  authDomain: "build-works.firebaseapp.com",
  databaseURL: "https://build-works.firebaseio.com",
  projectId: "build-works",
  storageBucket: "build-works.appspot.com"
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

// firebase collections
const testingCollection = db.collection("testing");
// const postsCollection = db.collection("posts");
// const commentsCollection = db.collection("comments");
// const likesCollection = db.collection("likes");

export {
  db,
  auth,
  currentUser,
  testingCollection
  //   usersCollection,
  //   postsCollection,
  //   commentsCollection,
  //   likesCollection
};
